import { FC, HTMLAttributes } from "react";
import { Button2, Type as T } from "@infobis/ui-styles-utils";
import st from './partnerCard.module.scss';
import { NavLink } from "react-router-dom";
import OperationsService from "@api/references/OperationsService";

interface IPartnerCard {
    headerText: string
    imgSrc: string
    description: string
    detailsButtonRoute?: string
    orderButton?: () => void
}

const PartnerCard: FC<IPartnerCard> = ({ headerText, imgSrc, description, detailsButtonRoute, orderButton }) => {
    return (
        <li className={ st['partner-card'] }>
            <figure className={ st['partner-fig'] }>
                <h3 className={ st['partner-fig__header'] }>{ headerText }</h3>
                <img className={ st['partner-fig__img'] } src={ imgSrc } alt={ 'partner image' }/>
                <figcaption className={ st['partner-fig__caption'] }>{ description }</figcaption>
            </figure>
            {(detailsButtonRoute || orderButton) && (
                <div className={st['controls']}>
                    {detailsButtonRoute && (
                        <NavLink style={{textDecoration: 'none', width: '100%'}} end to={detailsButtonRoute}>
                            <Button2.Secondary
                                className={st['controls__item']}
                                size={ T.Size.LARGE }
                            >
                                { 'Подробнее' }
                            </Button2.Secondary>
                        </NavLink>
                    )}
                    {orderButton && (
                            <Button2.Primary
                                className={st['controls__item']}
                                size={ T.Size.LARGE }
                                onClick={ () => orderButton!() }
                            >
                                { detailsButtonRoute ? 'Заказать' : 'Перейти' }
                            </Button2.Primary>
                    )}
                </div>
            )}
        </li>
    );
};

export default PartnerCard;